import config from '../../config'

const PAGE_SIZE = 25;

function sync_info(vue){
  vue.$store.commit('on_open_socket', function(){
      var cmd = {
        'command' : 'account_info',
        'account' : vue.id
      };

      vue.sendCmd(cmd, function(account){
        vue.have_info = true;
        vue.info = account["account_data"];
      });
  });
}

function sync_info_v2(vue){
  vue.$http.get(config.RIPPLE_DATAV2_URI + "accounts/" + vue.id)
           .then(function(response){
             vue.have_info_v2 = true;
             vue.info_v2 = response["body"]["account_data"];

           }, function(){
             vue.have_info_v2 = true;
             // try again ?
           });
}

function sync_trust_lines(vue, page){
  // FIXME: multi-page trust lines (like txs & ledger objects)
  vue.$store.commit('on_open_socket', function(){
      var cmd = {
        'command' : 'account_lines',
        'account' : vue.id
      };

      vue.sendCmd(cmd, function(tls){
        vue.have_trust_lines = true;
        vue.trust_lines = tls["lines"];
        vue.trust_lines_markers.push(tls["marker"] || null);
      });
  });
}

function sync_txs(vue, page){
  vue.have_txs = false;

  if(!page) page = 0;
  while(vue.txs.length <= page)
    vue.txs.push([]);
  while(vue.txs_markers.length <= page)
    vue.txs_markers.push(null);

  vue.$store.commit('on_open_socket', function(){
      var cmd = {
        'command' : 'account_tx',
        'account' : vue.id,
        'limit'   : PAGE_SIZE,
      };

      if(page != 0)
        cmd['marker'] = vue.txs_markers[page-1];

      vue.sendCmd(cmd, function(txs){
        vue.have_txs = true;
        vue.txs.splice(page, 1, txs["transactions"]);
        vue.txs_markers.splice(page, 1, txs["marker"] || null);
      });
  });
}

function sync_ledger_objects(vue, page){
  vue.have_ledger_objects = false;

  if(!page) page = 0;
  while(vue.ledger_objects.length < (page + 1))
    vue.ledger_objects.push([]);
  while(vue.ledger_objects_markers.length < (page + 2))
    vue.ledger_objects_markers.push(null);

  vue.$store.commit('on_open_socket', function(){
      var cmd = {
        'command' : 'account_objects',
        'account' : vue.id,
        'limit'   : PAGE_SIZE
      };

      if(page != 0)
        cmd['marker'] = vue.ledger_objects_markers[page-1];

      vue.sendCmd(cmd, function(objs){
        vue.have_ledger_objects = true;
        vue.ledger_objects.splice(page, 1, objs["account_objects"]);
        vue.ledger_objects_markers.splice(page, 1, objs["marker"] || null);
      });
  });
}

function sync_xchg_rates(vue){
  ["usd", "eur", "btc"].forEach(function(c){
    vue.$http.get("https://api.cryptonator.com/api/ticker/xrp-" + c)
             .then(function(r){
               vue.xchg_rates[c] = r["body"]["ticker"]["price"]
             });
  });
}

export default {
  data : function(){
    return {
                       info : {},
                    info_v2 : {},
                trust_lines : [],
                        txs : [],
             ledger_objects : [],
                 xchg_rates : {btc : null,
                               usd : null,
                               eur : null},

                  have_info : false,
               have_info_v2 : false,
           have_trust_lines : false,
                   have_txs : false,
        have_ledger_objects : false,

         trust_lines_markers : [],
                 txs_markers : [],
      ledger_objects_markers : []
    };
  },

  computed : {
    loading : function(){
      return !this.have_info           ||
             !this.have_info_v2        ||
             !this.have_trust_lines    ||
             !this.have_txs            ||
             !this.have_ledger_objects;
    },

    xrp_balance : function(){
      return this.info["Balance"] / config.DROPS_PER_XRP;
    },

    balances : function(){
      if(!this.xrp_balance)
        return {};

      return { xrp : this.xrp_balance,
               usd : this.xrp_balance * this.xchg_rates["usd"],
               eur : this.xrp_balance * this.xchg_rates["eur"],
               btc : this.xrp_balance * this.xchg_rates["btc"] }; 
    }
  },

  methods : {
    sync_account : function(){
      sync_info(this);
      sync_info_v2(this);
      sync_trust_lines(this);
      sync_txs(this);
      sync_ledger_objects(this);
      sync_xchg_rates(this);
    },

    sync_trust_lines : function(page){
      sync_trust_lines(this, page);
    },

    sync_txs : function(page){
      sync_txs(this, page);
    },

    sync_ledger_objects : function(page){
      sync_ledger_objects(this, page);
    }
  }
}
